import '../../scss/pages/home.scss';
import 'swiper/dist/css/swiper.css';

import Swiper from 'swiper';
import {ProductListItem} from "../libraries/product-list/ProductListItem";
import 'script-loader!../libraries/elfsight-instagram-feed';

import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';

defineElement(lottie.loadAnimation);

function initProductItems(items) {
    for (let item of items) {
        new ProductListItem(item);
    }
}

const Carousels = {
    mainBannerSlider: null,
    productsSlider: null,
    opinionsSlider: null,
    newProductsSlider: null,
    reviewSlider: null,

    init() {
        Carousels.mainBannerSlider = new Swiper('.home-page-banner-slider.swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="dot swiper-pagination-bullet"></span>`;
                },
            },
            autoplay: {
                delay: 9000,
            },
            preloadImages: false
        });

        const productsSlider = '.hobby-products-slider.swiper-container';
        Carousels.productsSlider = new Swiper(productsSlider, {
            slidesPerView: 'auto',
            spaceBetween: 46,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
            breakpoints: {
                768: {
                    spaceBetween: 25
                },
            },
            preloadImages: false
        });
        const productsSliderItems = document.querySelectorAll(productsSlider + ' .swiper-slide');
        initProductItems(productsSliderItems);

        Carousels.opinionsSlider = new Swiper('.features-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            autoplay: {
                delay: 4000,
            },
            scrollbar: {
                hide: false,
            },
            preloadImages: false
        });

        const newProductsSliderSelector = '.new-products-slider.swiper-container';
        Carousels.newProductsSlider = new Swiper(newProductsSliderSelector, {
            slidesPerView: 'auto',
            spaceBetween: 65,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
            breakpoints: {
                768: {
                    spaceBetween: 30
                },
            },
            preloadImages: false
        });
        const newProductsSliderItems = document.querySelectorAll(newProductsSliderSelector + ' .swiper-slide');
        initProductItems(newProductsSliderItems)


        // ----------------
        const reviewSliderSelector = '.reviews-slider.swiper-container';
        Carousels.reviewSlider = new Swiper(reviewSliderSelector, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
            breakpoints: {
                768: {
                    spaceBetween: 30
                },
            },
            preloadImages: false
        });
    }
};

function handleTextShowMore() {
    const button = document.querySelector('#text-description-show-more');

    if (!button) {
        return
    }

    button.addEventListener('click', (event) => {
        event.preventDefault();
        const content = document.querySelector('#test-description');

        if (!content) {
            return false;
        }

        content.style.height = 'auto';
        button.remove();
        return false;
    });
}

function initialize() {
    Carousels.init();
    handleTextShowMore();
}

initialize();
